import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M3.582 5.385c2.7-1.849 6.137-1.849 8.836 0a.765.765 0 0 1 .185 1.08l-1.984 2.718a.768.768 0 0 1-1.054.181 2.727 2.727 0 0 0-3.13 0 .768.768 0 0 1-1.054-.181L3.397 6.466a.765.765 0 0 1 .185-1.081Zm1.5.844L6.207 7.77c.32-.15.654-.258.993-.324l.336-.925a.75.75 0 1 1 1.41.513l-.15.412c.34.066.674.174.995.324l1.129-1.54a6.198 6.198 0 0 0-5.838 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M.25 3.002A1.75 1.75 0 0 1 2 1.25h12c.967 0 1.75.783 1.75 1.748l.01 10.003a1.75 1.75 0 0 1-1.75 1.752l-12.001-.004a1.75 1.75 0 0 1-1.75-1.748L.251 3ZM2 2.75a.25.25 0 0 0-.25.25l.01 10c0 .137.111.25.25.25l12 .003a.25.25 0 0 0 .25-.25L14.25 3a.25.25 0 0 0-.25-.25H2Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function a(r, s) {
  return l(), t("svg", o, [...d]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
